import {
  call,
  put,
  fork,
  select,
  takeLatest
} from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import {NORMALIZE_DATA} from '../../../dataProvider/dataProvider';
import dataProvider from '../../../../../util/dataProvider/dataProvider';
import {
  navigationRoutes,
  navigationSteps
} from '../../../navigation/navigationHelpers';
import {
  LOAD_CONTENT,
  DL_PAGE_LOADED
} from './confirmation';
import {
  SET_DATA
} from '../../../data/confirmation/confirmation';
import {
  showGlobalSpinner,
  hideGlobalSpinner,
  errorPageByFlow
} from '../../../common/common';

// WATCHERS
export function* loadContentWatch() {
  yield takeLatest(LOAD_CONTENT, loadContentWorker);
}

export function* normalizeWatch() {
  yield takeLatest(NORMALIZE_DATA, normalizeWorker);
}

// WORKERS
export function* loadContentWorker() {
  try {
    yield put(showGlobalSpinner({hideContent: true, initiator: 'localize load'}));

    const errorPage = yield select(errorPageByFlow);

    const success = yield call(dataProvider.load, [
      {state: 'auth'},
      {state: 'customer'},
      {state: 'context'},
      {state: 'plan'},
      {state: 'myplanConfirmation'}
    ], {errorPage});

    if (!success) {
      return;
    }

    yield put({
      type: DL_PAGE_LOADED
    });

    yield put(hideGlobalSpinner());
  } catch(e) {
    yield put(hideGlobalSpinner());
    browserHistory.push(navigationRoutes[navigationSteps.quickCheckout.ERROR].path);
  }
}

export function* normalizeWorker({key, data, meta}) {
  if (key !== 'myplanConfirmation') {
    return;
  }

  yield put({
    type: SET_DATA,
    payload: {
      ...meta,
      content: data
    }
  });
}

export default function* confirmationSagas() {
  yield [
    fork(loadContentWatch),
    fork(normalizeWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/MyPlan/confirmation/confirmationSagas.js
 **/